import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ClientEmployeeContactComponent } from './client-employee-contact.component';
import { ClientEmployeeContactRoutingModule } from './client-employee-contact-routing.module';
import { MyDatePickerModule } from 'mydatepicker';
import { DropDownListAllModule, ListBoxAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { GridModule } from '@syncfusion/ej2-angular-grids';
@NgModule({
  declarations: [ClientEmployeeContactComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaskedTextBoxModule,
    NgSelectModule,
    ClientEmployeeContactRoutingModule,
    MyDatePickerModule,
    DropDownListAllModule,
    NgbModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    ListBoxAllModule,
    NgxUiLoaderModule,
    GridModule,
  ],
  exports: [ClientEmployeeContactComponent]
})
export class ClientEmployeeContactModule { }
